/* ===========================================================================
 * F278(9-136, 사장님 확정): 반응형 표 — **전체 기본**.
 *
 * 넓은 화면은 보통 표. 좁아지면(PAD·모바일) 각 행이 카드가 되어 **모든 열이
 * 보인다** — 지금까지는 table-responsive 의 가로 스크롤에 열이 숨었다.
 * CSS 만으로는 각 칸에 열 이름을 못 붙인다(카드 모드의 라벨은
 * `td::before{content:attr(data-th)}`). 그래서 부팅 때 한 번, thead 의 열
 * 이름을 각 td 에 복사한다. ui.table() 창구가 nx-rtable 을 붙이므로
 * 화면 쪽 코드는 아무것도 안 해도 된다.
 *
 * ★ 서버 렌더 행에만 필요하다 — 지금 모든 표(MY DOX·MY CREDITS)가 서버
 *   렌더다. JS 로 행을 갈아끼우는 표가 생기면 그 코드가 stampRtable 을
 *   다시 부르면 된다(idempotent).
 * =========================================================================== */

export function stampRtable(root?: ParentNode): void {
  const scope = root || document;
  for (const table of Array.from(scope.querySelectorAll<HTMLTableElement>('table.nx-rtable'))) {
    const ths = Array.from(table.querySelectorAll<HTMLTableCellElement>('thead th'));
    if (!ths.length) continue;
    const labels = ths.map((th) => (th.textContent || '').trim());
    for (const tr of Array.from(table.querySelectorAll<HTMLTableRowElement>('tbody tr'))) {
      Array.from(tr.cells).forEach((td, i) => {
        if (!td.hasAttribute('data-th') && labels[i]) td.setAttribute('data-th', labels[i]);
      });
    }
  }
}

export function initRtable(): void {
  stampRtable();
}
